module.exports = __webpack_public_path__ + "static/img/V3.689af9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/V3.png
// module id = UM4s
// module chunks = 1